import { jsx as a } from "react/jsx-runtime";
import { useState as p } from "react";
import { useMatchMedia as T } from "../../../hooks/useMatchMedia.js";
import "../../Scale/ScaleContext.js";
import "lz-string";
import { Theme as e } from "../ThemeContext.js";
import { ThemeProvider as f } from "../ThemeProvider/ThemeProvider.js";
const y = "(prefers-color-scheme: dark)", M = (t) => {
  const { children: m, initialTheme: o = e.auto, getTheme: s, saveTheme: i } = t, h = T(y) ? e.dark : e.light, [n, c] = p(() => s() || o);
  return /* @__PURE__ */ a(f, { onThemeChange: (r) => {
    i(r), c(r);
  }, theme: n, systemTheme: h, children: m });
};
export {
  M as ThemeSyncWithSystemProvider
};
